import React, { Component } from 'react';
import { ButtonToolbar, Button, Table, Row, Col, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { CurrenciesForm } from './CurrenciesForm';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { CurrenciesCommand } from '../commands/CurrenciesCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';
import { TitleRow } from '../../TitleRow';
import { TableButton } from '../../TableButton';

import ColumnResize from "react-table-column-resizer";

export class Currencies extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string
    }

    constructor(props) {
        super(props);

        this.state = {
            commands: {
                currencies: new CurrenciesCommand()
            },
            table: {
                data: [],
                page: 1,
                elementsPerPage: 50,
                filter: ""
            },
            form: {
                title: undefined,
                setOfDayTypes: undefined,
                original: undefined
            },
            actions: {
                isLoading: true,
                isUpdating: false,
                isDeleting: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        this.getCurrencies();
    }

    // ---------------------------

    getCurrencies(resetData = false) {
        if (resetData) {
            const { table } = this.state;

            table.data = [];

            this.setState({
                table: table
            });
        }

        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoading = true;
        commands.currencies.getAll(
            selectedProviderId,
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    // ---------------------------

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    listErrorCallback(messageReceived) {
        const { table, actions, message } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getCurrencies();
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onCreateClick() {
        const { form } = this.state;

        form.original = null;
        form.model = {
            id: 0,
            name: "",
            symbol: "",
        };
        form.title = "Criar";

        this.setState({
            form: form
        });
    }

    onEditClick(data) {
        const { form } = this.state;

        form.original = data;
        form.model = Object.assign({}, data);
        form.title = "Editar";

        this.setState({
            form: form
        });
    }

    onDeleteClick(model) {
        const { selectedProvider } = this.context;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a Moeda "${model.name}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    id: model.id,
                    provider: selectedProviderId
                }
            }
        });
    }

    onSave(data) {
        const { selectedProvider } = this.context;
        const { commands, actions } = this.state;

        let selectedProviderId = '';
        if (selectedProvider !== undefined) {
            selectedProviderId = selectedProvider.split(':')[0];
        }

        commands.currencies.save(
            selectedProviderId,
            data,
            (a) => this.operationSuccessCallback(a, "isUpdating"),
            (a) => this.operationErrorCallback(a, "isUpdating")
        );

        actions.isUpdating = true;
        this.setState({
            actions: actions
        });

        this.onFormExit();
    }

    onFormExit() {
        this.setState({
            form: {
                title: undefined,
                model: undefined,
                original: undefined,
            }
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const { commands } = this.state;
            commands.currencies.delete(
                argument.provider,
                argument.id,
                (a) => this.operationSuccessCallback(a, "isDeleting"),
                (a) => this.operationErrorCallback(a, "isDeleting")
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // -----------------

    onChangePage(page) {
        const { table } = this.state;

        table.page = page;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elements) {
        const { table } = this.state;

        table.elementsPerPage = elements;

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    // ---------------

    renderForm() {
        const { form } = this.state;

        if (null === form.model || undefined === form.model) {
            return null;
        }

        return (
            <CurrenciesForm title={form.title}
                model={form.model}
                onSave={(a) => this.onSave(a)}
                onHide={() => this.onFormExit()} />
        );
    }

    renderLoading(isLoading) {
        if(isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable(isWaiting) {
        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name", "symbol"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <div className="table-loading">
                            <Table responsive striped hover>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>Símbolo</th>
                                        <ColumnResize className="columnResizer" />
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        partialData.map((data, i) =>
                                            <tr key={`set-${i}`}>
                                                <td>{data.name}</td>
                                                <td className="column_resizer_body" />
                                                <td>{data.symbol}</td>
                                                <td className="column_resizer_body" />
                                                <td>
                                                    <ButtonToolbar className="pull-right">
                                                        <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.onEditClick(data)} />
                                                        <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteClick(data)} />
                                                    </ButtonToolbar>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>

                            <PaginationBuilder
                                currentPage={activePage}
                                elementsPerPage={table.elementsPerPage}
                                dataLength={dataFiltered.length}
                                onChangePage={(a) => this.onChangePage(a)}
                                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />

                            {this.renderLoading(isWaiting)}
                        </div>
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        const { actions, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Moedas" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                {this.renderTable(actions.isLoading || actions.isUpdating || actions.isDeleting)}
                {this.renderForm()}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}
